// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3fSUn","footer":"ChangeClinic_footer__3uzK4"};